export default "__VITE_ASSET__DEfHim8O__"